import React, { Component } from 'react';
import util from '../../util'
import css from './basket.module.css'
import crossIcon from '../../cross.svg'
import jsPDF from 'jspdf';


export default class Basket extends Component {

    render() {
        const { cartItems } = this.props;
        const productsArr = []
        const products = cartItems.map(
            (i) => productsArr.push(
                i.title + ' ' + i.count + '*' + i.price + '=' + i.count * i.price
            )
        )

        const totalPrice = util.formatCurrency(cartItems.reduce((a, c) => (a + c.price * c.count), 0))

        const getReceipt = () => {
            // console.log('receipt');

            let doc = new jsPDF('p', 'pt')

            doc.setFont('courier')
            doc.setFontType('bold')
            doc.text(150, 20, 'Thank you for being with us !')
            doc.setFontType('normal')
            doc.text(100, 35, '***************************************')
            doc.text(200, 60, productsArr)
            doc.text(100, 180, '***************************************')
            doc.setFontType('bold')
            doc.setFontSize(14)
            doc.text(180, 195, `Total price : ${totalPrice} `)

            doc.save("Akmaral.pdf")

            // ********************************************************************

            // var generateData = function (amount) {
            //     var result = [];
            //     var data = {
            //         product: "Hamburger",
            //         count: "2",
            //         price: "80",
            //         sum: "160",
            //     };
            //     for (var i = 0; i < amount; i += 1) {
            //         data.id = (i + 1).toString();
            //         result.push(Object.assign({}, data));
            //     }
            //     return result;
            // };

            // function createHeaders(keys) {
            //     var result = [];
            //     for (var i = 0; i < keys.length; i += 1) {
            //         result.push({
            //             id: keys[i],
            //             name: keys[i],
            //             prompt: keys[i],
            //             width: 65,
            //             align: "center",
            //             padding: 0
            //         });
            //     }
            //     return result;
            // }

            // var headers = createHeaders([
            //     "id",
            //     "Product",
            //     "Count",
            //     "Price",
            //     "Sum",
            // ]);

            // var doc = new jsPDF({ putOnlyUsedFonts: true, orientation: "landscape" });
            // doc.table(1, 1, generateData(100), headers, { autoSize: true });
            // doc.save("Akmaral.pdf")

        }


        return (
            <div className={css.basket}>
                {cartItems.length === 0
                    ? "Basket is empty" :
                    <h3>You have {cartItems.length} items in the basket. <hr /></h3>
                }
                <br />
                <b>Sum: {util.formatCurrency(cartItems.reduce((a, c) => (a + c.price * c.count), 0))}</b>
                <br />
                <br />

                {cartItems.length > 0 &&
                    <div>
                        <ul style={{ marginLeft: -25 }}>
                            {cartItems.map(item => (
                                <li className={css.meal} key={item.id}>

                                    <div className={css.item}>
                                        <b>{item.title}</b>
                                    </div>

                                    <span>
                                        {item.count} * {util.formatCurrency(item.price)}
                                    </span>

                                    <button style={{ float: 'right' }} className={css.crossBtn}
                                        onClick={(e) => this.props.handleRemoveFromCart(e, item)}>
                                        <img src={crossIcon} alt="x" />
                                    </button>
                                </li>))
                            }
                        </ul>

                    </div>
                }
                <button className={css.discountBtn} onClick={getReceipt}>
                    Click to get a receipt
                </button>
            </div>
        )
    }
}